import { getNoCatch, postNoCatch } from '@api/request';

const prefix = '/api/domestic_consultation_form';

export const api = {
  /**
   * 获取国内咨询单列表
   */
  getDomesticConsultationFormList: params => getNoCatch(`${prefix}/get_domestic_consultation_form_list`, params),

  /**
   * 批量新增国内咨询单
   */
  addDomesticConsultationForm: params => postNoCatch(`${prefix}/add_domestic_consultation_form`, params),

  /**
   * 更新上传状态
   */
  updateUploadStatus: params => getNoCatch(`${prefix}/update_upload_status`, params),

  /**
   * 回传相关资料
   */
  updateCallbackStatus: params => getNoCatch(`${prefix}/update_callback_status`, params),

  /**
   * 获取国内咨询单提醒未读数
   */
  getPush9011Count: params => getNoCatch(`${prefix}/get_push9011_count`, params),

  /**
   * 获取国内咨询单提醒列表
   */
  getPush9011List: params => getNoCatch(`${prefix}/get_push9011`, params),

  /**
   * 删除/标记已处理国内咨询单提醒
   */
  deletePush9011: params => getNoCatch(`${prefix}/delete_push9011`, params)
};
